import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute4 = ({
  width = 142,
  height = 262,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 437,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 142 262"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M0.500007,-32.5C33.6961,1.89725 65,17.5 112.261,79.1259C176.07,162.331 118.67,207.412 72.5601,198.568C26.4499,189.724 27.5705,245.102 55.7148,251.098C60.2646,252.067 65.9535,255.581 72.3371,261"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M0.500007,-32.5C33.6961,1.89725 65,17.5 112.261,79.1259C176.07,162.331 118.67,207.412 72.5601,198.568C26.4499,189.724 27.5705,245.102 55.7148,251.098C60.2646,252.067 65.9535,255.581 72.3371,261"
      />
    </svg>
  )
}

export default ExpeditionRoute4
